export const reportAdrumLogs = errorMsg => {
  try {
    if (process.env.REACT_APP_APP_DYNAMICS_LOGS_ENABLED === "Y") {
      reportAdrum(errorMsg);
    }
  } catch (e) {
    //
  }
};

export const reportAdrum = errorMsg => {
  try {
    const errMsg = errorMsg.substr(0, 2000);
    let appdErrorObj = new window.ADRUM.events.Error();
    appdErrorObj.msg(errMsg);
    window.ADRUM.report(appdErrorObj);
  } catch (e) {
    //
  }
};
